<template>
  <v-list-group :value="false" active-class="left-amber-border black--text">
    <template v-slot:activator>
      <v-list-item-icon class="pl-2">
        <v-icon>mdi-account-network</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="text-uppercase">Quản trị</v-list-item-title>
    </template>
    <v-list class="left-amber-border py-0">
      <!-- <v-list-item> -->
        <!-- <v-list-group
          active-class="left-amber-border black--text"
          class="flex-fill long-term-sub-list"
        >
          <template v-slot:activator>
            <v-list-item-title class="pr-0">Học viên dài hạn</v-list-item-title>
          </template>
          <v-list>
            <v-list-item exact link to="/students?type=long_term&status=active">
              <v-list-item-title class="pl-4">Đang học</v-list-item-title>
            </v-list-item>
            <v-list-item exact link to="/reserved-students?type=long_term">
              <v-list-item-title class="pl-4">Bảo lưu</v-list-item-title>
            </v-list-item> -->
        <!-- <v-list-item exact link to="/students?type=long_term&status=aborted">
              <v-list-item-action></v-list-item-action>
              <v-list-item-title class="ml-3">Thôi học</v-list-item-title>
            </v-list-item>
            <v-list-item exact link to="/students?type=long_term&status=graduated">
              <v-list-item-action></v-list-item-action>
              <v-list-item-title class="ml-3">Đã kết thúc CT</v-list-item-title>
            </v-list-item> -->
        <!-- </v-list>
        </v-list-group> -->
      <!-- </v-list-item> -->
      <!-- <v-list-item>
        <v-list-group
          active-class="left-amber-border black--text"
          class="flex-fill short-term-sub-list"
        >
          <template v-slot:activator>
            <v-list-item-title class="px-0">Học viên ngắn hạn</v-list-item-title>
          </template>
          <v-list>
            <v-list-item exact link to="/students?type=short_term&status=active">
              <v-list-item-title class="pl-4">Đang học</v-list-item-title>
            </v-list-item>

            <v-list-item exact link to="/students?type=short_term&status=graduated">
              <v-list-item-action></v-list-item-action>
              <v-list-item-title class="ml-3">Đã kết thúc CT</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-list-group>
      </v-list-item> -->
      <v-list-item link to="/students">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Học viên</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/teachers">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Giảng Viên</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/reserved-students">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Bảo lưu</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/abortions">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Thôi học</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/graduations">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Tốt nghiệp</v-list-item-title>
      </v-list-item>
      <!-- <v-list-item link to="/staffs" v-if="policies['view-staff-list']">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Nhân Viên</v-list-item-title>
      </v-list-item> -->
      <v-list-item link to="/managers" v-if="['super_admin'].includes(role.type)">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Nhân viên</v-list-item-title>
      </v-list-item>

      <v-list-item link to="/facilities">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Cơ Sở Vật Chất</v-list-item-title>
      </v-list-item>
      <!-- <v-list-item link to="/reservation">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Bảo Lưu</v-list-item-title>
      </v-list-item> -->
      <v-list></v-list>
    </v-list>
  </v-list-group>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return { menu: null }
  },
  computed: {
    ...mapGetters('app', ['department', 'policies']),
    ...mapGetters('auth', ['user', 'role'])
  }
}
</script>

<style scoped>
::v-deep {
  .long-term-sub-list .v-list-group__header {
    padding-right: 0px;
  }

  .short-term-sub-list .v-list-group__header {
    padding-right: 0px;
  }
}
</style>
